module.exports = __webpack_public_path__ + "static/image/logo-h.6d1d6f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-h.png
// module id = 375
// module chunks = 1